<ra-modal
    [title]="('document.edit.documentQrCode.title' | translate)"
    [size]="'small'"
    (close)="close.emit()">

    <div class="qrcode-body">

        <!-- QR emoldurado — a borda vira a "etiqueta" que o usuário vai recortar -->
        <div class="qr-frame">
            @if (qrDataUrl(); as dataUrl) {
                <img class="qr-image" [src]="dataUrl" alt="QR Code" />
            } @else {
                <div class="qr-loading">
                    <ra-loading [size]="'small'" />
                </div>
            }
        </div>

        <p class="qr-hint">{{ 'document.edit.documentQrCode.hint' | translate }}</p>

        <!-- Documento privado: quem escanear vai esbarrar em login/código -->
        @if (isPrivate()) {
            <div class="qr-private-warning">
                <ra-icon icon="lock" varColor="accentOrange" [size]="18" />
                <span>{{ 'document.edit.documentQrCode.privateWarning' | translate }}</span>
            </div>
        }

        <div class="qr-actions">
            <ra-button
                [label]="'document.edit.documentQrCode.print' | translate"
                [type]="'primary-outline'"
                [disabled]="!qrDataUrl()"
                (click)="print()">
            </ra-button>

            <!-- Download direto do data URL — sem passar por servidor -->
            <a class="qr-download" [href]="qrDataUrl()" [download]="downloadFileName()">
                <ra-button
                    [label]="'document.edit.documentQrCode.savePng' | translate"
                    [type]="'primary'"
                    [disabled]="!qrDataUrl()">
                </ra-button>
            </a>
        </div>
    </div>
</ra-modal>
